import React from 'react'
import LinkButton from '@components/common/LinkButton'
import SoftDropdownButton from '../../common/SoftDropDownButton'

const MainMenu = ({ openMegaMenu, handleMenu }) => {
  return (
    <React.Fragment>
      <section className="relative gap-x-6 text-black text-sm ml-8">
        {/* DESKTOP */}
        <section className="hidden lg:flex justify-between flex-row items-start lg:items-center max-w-[1440px] mx-auto flex-1 gap-x-6 xl:gap-x-8 gap-y-8">
          <SoftDropdownButton
            label={"SHOP"}
            onClick={handleMenu}
            disableDefaultDropdown={true}
            openOnHover={true}
            className={'flex-1 justify-between'}
            isOpenRef={openMegaMenu}
          />
          <LinkButton label={'NEW'} to={"/collections/new-arrivals/"} ariaLabel='NEW' />
          <LinkButton label={'BEST SELLERS'} to="/collections/bestsellers" ariaLabel='BEST SELLERS' />
          <LinkButton label={'CORE COLLECTION'} to="/collections/the-core-collection" ariaLabel='CORE COLLECTION' />
          {/* <LinkButton
            to={`/bikini-paradise`}
            label={'BIKINI PARADISE MAP'}
            ariaLabel="BIKINI PARADISE MAP"
          /> */}
          <LinkButton className={'text-danger-light'} label={'SALE'} to={"/collections/sale"} ariaLabel='SALE' />
        </section>
      </section>
    </React.Fragment>
  );
}

export default MainMenu